import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

export const getDefinitionByAPIField = (
  definitions: SimpleFilterDefinition[] | null,
  apiField: string
): SimpleFilterDefinition | undefined => {
  if (!definitions) {
    return undefined;
  }

  for (const def of definitions) {
    if (def.apiField === apiField) {
      return def;
    }
  }
};

export const getDefinitionByUIField = (
  definitions: SimpleFilterDefinition[] | null,
  uiField: string
): SimpleFilterDefinition | undefined => {
  if (!definitions) {
    return undefined;
  }

  for (const def of definitions) {
    if (def.uiField === uiField) {
      return def;
    }
  }
};

export const getDefinitionForQueryFilter = (
  definitions: SimpleFilterDefinition[] | null,
  queryFilter: QueryFilter
): SimpleFilterDefinition | undefined => {
  if (!definitions) {
    return undefined;
  }

  const retrieved: SimpleFilterDefinition[] = [];
  for (const def of definitions) {
    if (def.apiField === queryFilter.field) {
      retrieved.push(def);
    }
  }

  if (retrieved.length === 0) {
    return undefined;
  }

  if (retrieved.length === 1) {
    return retrieved[0];
  }

  for (const def of retrieved) {
    if (def.matchesQueryFilter && def.matchesQueryFilter(queryFilter)) {
      return def;
    }
  }

  return retrieved[0];
};

export const getDefinitionForSimpleFilter = (
  definitions: SimpleFilterDefinition[] | null,
  simpleFilter: SimpleFilter
): SimpleFilterDefinition | undefined => {
  if (!definitions) {
    return undefined;
  }

  const retrieved: SimpleFilterDefinition[] = [];
  for (const def of definitions) {
    if (def.uiField === simpleFilter.field) {
      retrieved.push(def);
    }
  }

  if (retrieved.length === 0) {
    return undefined;
  }

  if (retrieved.length === 1) {
    return retrieved[0];
  }

  for (const def of retrieved) {
    if (def.matchesSimpleFilter && def.matchesSimpleFilter(simpleFilter)) {
      return def;
    }
  }

  return retrieved[0];
};
